module.exports = __webpack_public_path__ + "img/bg-img-two.0c3fb540.png";